<kendo-dialog title="Delete Schedule" (close)="deleteSchedule('no')" class="delete-schedule-dialog app-dialog"
  [minWidth]="250" [width]="400">
  <p class="important" style="margin: 10px; text-align: center;">{{configText}}</p>
  <kendo-dialog-actions id="deleteDialogBtn">
    <button kendoButton id="no-delete-schedule" (click)="deleteSchedule('no')" [disabled]="loading"
      primary="true">No</button>
    <button kendoButton id="yes-delete-schedule" (click)="deleteSchedule('yes')" primary="true" [disabled]="loading">
      <span *ngIf="!loading">Yes</span>
      <span *ngIf="loading" class="k-i-loading k-icon"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
